import React from 'react';
import { SORT_DIR } from './utils/constants';

function TableHeader({
    visibleColumns,
    sortKey,
    sortDir,
    onSortChange,
    selectable,
    allSelected,
    onToggleAllSelect,
    stickyOffsets,
    getResizeHandleProps,
    resetColumnWidth,
    getDragHandleProps,
    dragState,
    isResizing,
}) {
    return (
        <thead className="ut-thead">
            <tr>
                <th className="ut-th ut-th--row-actions ut-th--sticky" style={{ left: 0 }}>
                    {selectable && (
                        <input
                            type="checkbox"
                            className="ut-select-all"
                            checked={allSelected}
                            onChange={onToggleAllSelect}
                            title="Выбрать все"
                        />
                    )}
                </th>

                {visibleColumns.map((col) => {
                    const isSorted = sortKey === col.key;
                    const sortable = col.sortable !== false;
                    const resizable = col.resizable !== false;
                    const stickyLeft = stickyOffsets[col.key];
                    const isSticky = stickyLeft != null;
                    const isDragging = dragState?.dragging === col.key;
                    const isDropTarget = dragState?.dropTarget === col.key;
                    const dropSide = dragState?.dropSide;

                    const thClassName = [
                        'ut-th',
                        sortable ? 'ut-th--sortable' : '',
                        isSticky ? 'ut-th--sticky' : '',
                        isSorted ? 'ut-th--sorted' : '',
                        col.align === 'right' ? 'ut-th--right' : '',
                        col.align === 'center' ? 'ut-th--center' : '',
                        isDragging ? 'ut-th--dragging' : '',
                        isDropTarget && dropSide ? `ut-th--drop-${dropSide}` : '',
                    ].filter(Boolean).join(' ');

                    const style = {
                        width: col.width || undefined,
                        minWidth: col.minWidth || col.width || undefined,
                    };
                    if (isSticky) {
                        style.left = stickyLeft;
                    }

                    const dragProps = getDragHandleProps
                        ? getDragHandleProps(col.key, isSticky)
                        : {};

                    const resizeProps = resizable && getResizeHandleProps
                        ? getResizeHandleProps(
                            col.key,
                            col.width,
                            // исходный minWidth колонки: col.minWidth после ресайза
                            // равен текущей ширине и заблокировал бы сжатие
                            col.resizeMinWidth ?? col.minWidth,
                            col.maxWidth,
                        )
                        : null;

                    return (
                        <th
                            key={col.key}
                            className={thClassName}
                            style={style}
                            // col.hint — пояснение к показателю: как считается и
                            // что означает. Показывается всплывающей подсказкой.
                            title={col.hint || undefined}
                            onClick={sortable && !isResizing ? () => onSortChange(col.key) : undefined}
                            {...dragProps}
                        >
                            <div className="ut-th-content">
                                <span className="ut-th-label">{col.header}</span>
                                {sortable && (
                                    <span className="ut-sort-indicator">
                                        {isSorted
                                            ? sortDir === SORT_DIR.ASC ? '↑' : '↓'
                                            : '⇅'}
                                    </span>
                                )}
                            </div>
                            {resizable && resizeProps && (
                                <div
                                    className="ut-resize-handle"
                                    onMouseDown={resizeProps.onMouseDown}
                                    onDoubleClick={(e) => {
                                        e.stopPropagation();
                                        if (resetColumnWidth) resetColumnWidth(col.key);
                                    }}
                                    onClick={(e) => e.stopPropagation()}
                                />
                            )}
                        </th>
                    );
                })}
            </tr>
        </thead>
    );
}

export default React.memo(TableHeader);
